<template>
	<div>
		<div class="row">
			<div class="col-md-4 mb-4">
				<info-card
					:title="'Total de cancelamentos'"
					icon="fa-ban"
					variant="danger"
					:value="totalCaceled.total_canceled"
				/>
			</div>
		</div>

		<br />

		<br />
		<div class="row grid-table-heading d-md-flex d-none">
			<div class="col-md-6">Descrição</div>
			<div class="col-md-6">
				<div class="row">
					<div class="col-3 text-right">
						Valor Original
					</div>
					<div class="col-3 text-right">
						Saldo Devedor
					</div>
					<div class="col-3 text-right">
						Vencimento
					</div>
					<div class="col-3 text-right">
						Status
					</div>
				</div>
			</div>
		</div>
		<hr />
		<table-paginator :data="bills" @pagechange="select($event)">
			<template v-for="row in bills.data">
				<div
					class="row grid-table-row align-items-md-center align-items-start"
					:key="row.id"
				>
					<div class="col-8 col-md-6 d-flex">
						<div class="ml-2">
							<span>Documento: {{ row.document }}</span>
							<br />
							<small class="text-muted">Ver compras</small>
						</div>
					</div>

					<div class="col-4 col-md-6">
						<div class="row">
							<div class="col-md-3 text-right d-none d-md-inline">
								{{ row.value | decimal }}
							</div>
							<div class="col-md-3 text-right">
								<b>{{ (row.value - row.received_value) | decimal }}</b>
							</div>
							<div class="col-md-3 text-right">
								<due-date-badge ref="DueDateBadge" :date="row.due_date" />
								<!-- <span :class="['badge', 'text-white', getDueDateBadge(row.due_date, row.status)]" style="line-height:1.2">{{ row.due_date | dateBr }}</span> -->
							</div>
							<div class="col-md-3 text-right">
								<span
									:class="['badge', 'text-white', status[row.status].class]"
									style="line-height:1.2"
									>{{ status[row.status].text }}</span
								>
							</div>
						</div>
					</div>
				</div>
			</template>
		</table-paginator>
		<receive-bill-receive-form ref="receiveBillReceiveForm" @stored="select" />
		<bill-receiveble-cancel-form
			ref="billReceivebleCancelForm"
			@canceled="refresh"
		/>
		<bill-payment-list ref="billPaymentList" />
	</div>
</template>

<script>
	import Filters from "../../../mixins/Filters";
	import moment from 'moment';
import InfoCard from '../../sections/dashboard/InfoCard.vue';
	import ReceiveBillReceiveForm from '../forms/ReceiveBillReceiveForm';
	import BillReceivebleCancelForm from '../forms/BillReceivebleCancelForm.vue';
	import BillPaymentList from '../lists/BillPaymentList'
	import DueDateBadge from '../../ui/DueDateBadge.vue';
import TablePaginator from '../../sections/TablePaginator.vue';

	export default {
		props: {
			id: {}
		},

		components: {
			InfoCard,
			ReceiveBillReceiveForm,
			BillReceivebleCancelForm,
			BillPaymentList,
			DueDateBadge,
			TablePaginator
		},

		data: function () {
			return {

				searchForm: {
					id: null,
					name: null,
					status: 'c'
				},

				bills: {},

				totalCaceled: {},

				status: {
					o: {
						text: "Aberto",
						class: "badge-primary"
					},

					p: {
						text: "Pago",
						class: "badge-success"
					},

					c: {
						text: "Cancelado",
						class: "badge-danger"
					},

					r: {
						text: "Renegociado",
						class: "badge-warning"
					}
				},

			};
		},

		created() {

			this.searchForm.id = this.id
			this.select()

			// this.$store.commit("pageHasLoaded");
			// axios
			// 	.post("api/billreceiveble/selectcancel", this.searchForm)
			// 	.then(response => {
			// 		this.bills = response.data.cancel;
			// 		this.totalCaceled = response.data.cancelValue;

			// 	})
			// 	.catch(error => {
			// 		this.error = error;
			// 	});
		},



		methods: {

			openBillReceiveCancelForm(bills) {
				this.$refs.billReceivebleCancelForm.open(bills);
			},

			printBillReceiveble(bills) {
				window.open("/contasareceber/imprimir-recibo/" + bills.id, "_blank");
			},

			printBillPromissory(bills) {
				window.open("/contasareceber/imprimir-promissoria/" + bills.id, "_blank");
			},

			openReceiveBillReceiveForm() {
				this.$refs.receiveBillReceiveForm.open(this.selected);
			},

			refresh() {
				this.selected = [];
				// todo select current page
				// this.created();
			},

			select(page = 1) {
				this.$store.commit("pageHasLoaded");
				axios
					.post("api/billreceiveble/selectcancel?page=" + page, this.searchForm)
					.then(response => {
						this.bills = response.data.cancel;
						this.totalCaceled = response.data.cancelValue;
					})
					.catch(error => {
						this.error = error;
					});

			},


			getWhatsAppLink(bills) {

				let name = bills.name.replace(/ .*/, '');
				let link = 'https://api.whatsapp.com/send?phone=+55' + bills.phone_wa
				let msg = '&text=Olá ' + name + ', temos um valor em aberto referente a' +
					'sua última compra com a loja ' + this.$store.state.company.name + ' Aguardamos você para novas compras e tomar  cafézinho delicioso com a gente.!'

				return link + msg
			},

		}

	}
</script>

<style>

</style>
